import { Common } from '@icc/shared/helpers';
import {PriceFunc, PriceElemsData, PriceSegment, getListPrice} from '@icc/price';
import {Injectable, Inject} from '@angular/core';
import { APP_CONFIG, AppConfigFactory } from '@icc/shared/config';

@Injectable()
export class PriceHandlePositionService {

    constructor(
        @Inject(APP_CONFIG) private config: AppConfigFactory,
    ) {}

    /**
     * Dodawanie dopłaty do zmiany pozycji klamki
     * @param  {Number} price         Cena
     * @param  {Array} PriceElems     Składowe ceny
     * @param  {Object} model         Model
     * @param  {Object} colors        Kolory
     * @param  {Number} sashesCount   Liczba skrzydeł
     * @param  {Object} NoPriceCauses Powody braku ceny
     * @return {Number}               Cena
     */
    @PriceFunc({
        shortName: 'handlePosition',
        data: {
            system: 'conf.System',
            sashes: 'conf.Sashes',
        }
    })
    suppHandlePosition({PriceStack, PriceElems, NoPriceCauses, listPrice}: PriceElemsData, {system, sashes}): PriceSegment[] {
        if (Common.isObject(system)
            && Common.isDefined(system.handle_position_surcharge)
            && parseFloat(system.handle_position_surcharge) > 0
        ) {
            const sashesCount = sashes.filter(sash => sash.type.type === 'K' && sash.type.handle_position && sash.type.handle_position !== 'T').length;
            const listPriceEnableInMarket = this.config().IccConfig.Offer.listPrice ? this.config().listPriceEnableInMarket : true;

            const supp = parseFloat(getListPrice(system, 'handle_position_surcharge', listPrice, listPriceEnableInMarket)) * sashesCount;
            return supp ? <PriceSegment[]>[{
                type: 'handlePosition',
                baseValue: supp,
                value: supp,
                valueType: 'value',
                data: {
                    id   : system.id,
                    name : system.name,
                    count: sashesCount,
                }
            }] : [];
        }

        return [];
    }
}

